<template>
<div class="chapter">
<div class="inner_page">
<p class="cover" id="page_11"><img alt="Half Title of Paul" src="images/11.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 008_FM01.vue?656b230e